/* src/app/shared-module/components/header-tool-bar/header-tool-bar.component.scss */
.blink_me {
  animation: blinker 1s linear infinite;
  color: #e35655;
  background: white;
  width: 72px;
  text-align: center;
  padding: 3px 4px 2px 3px;
  margin-right: 10px;
}
@keyframes blinker {
  50% {
    opacity: 0;
  }
}
/*# sourceMappingURL=header-tool-bar.component.css.map */
